import React from "react";
import styled from "styled-components";
import { Image as ImageIcon } from "react-feather";
import { IAssetResponse } from "../../../interfaces";
import { useScreenshotUrl } from "./use-screenshot-url";

const Thumbnail = styled.div`
  min-width: 120px;
  height: 80px;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  cursor: pointer;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f8f9fa;
  transition: border-color 0.2s;

  &:hover {
    border-color: #007bff;
  }
`;

const ThumbnailImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const PlaceholderIcon = styled(ImageIcon)`
  color: #6c757d;
  width: 24px;
  height: 24px;
`;

interface Props {
  taskId: string;
  activityId: string;
  screenshot: IAssetResponse;
  index: number;
  onClick: () => void;
}

export const ScreenshotThumbnail: React.FC<Props> = ({
  taskId,
  activityId,
  screenshot,
  index,
  onClick,
}) => {
  const { url } = useScreenshotUrl(taskId, activityId, screenshot._id);

  return (
    <Thumbnail onClick={onClick}>
      {url ? (
        <ThumbnailImage src={url} alt={`Screenshot ${index + 1}`} />
      ) : (
        <PlaceholderIcon />
      )}
    </Thumbnail>
  );
};
